import { superAdminApi } from "../authService";
import {
  PaginatedApiResponse,
  PaginationParams,
} from "../../types/api";

const RESOURCE = "/super-admin/activity-logs";

export const ACTIVITY_LOG_ACTION_OPTIONS = [
  "impersonation_write",
  "impersonation.start",
  "tenants.block",
  "tenants.unblock",
  "tenants.subscription.update",
  "tenants.subscription.activate",
  "tenants.subscription.sync_gateway",
  "tenants.users.invite",
  "tenants.users.update",
  "tenants.users.revoke_membership",
  "tenants.professionals.create",
  "tenants.professionals.update",
  "tenants.professionals.archive",
  "tenants.professionals.restore",
  "tenants.professionals.invite",
  "accounts.delete_orphan",
  "accounts.delete_force",
  "accounts.revoke_google",
  "accounts.invalidate_tokens",
  "plans.create",
  "plans.update",
  "plans.delete",
  "plans.deactivate",
  "email_suppressions.create",
  "email_suppressions.delete",
  "email_suppressions.import",
  "email_circuit.reset",
] as const;

export type ActivityLogActionOption =
  (typeof ACTIVITY_LOG_ACTION_OPTIONS)[number];

export interface ActivityLogActor {
  id: number;
  name: string;
}

export interface ActivityLog {
  id: number;
  action: string;
  route: string;
  ip_address: string;
  old_values: Record<string, unknown> | null;
  new_values: Record<string, unknown> | null;
  super_admin: ActivityLogActor | null;
  user: ActivityLogActor | null;
  created_at: string;
  updated_at: string;
}

export interface ActivityLogListParams extends PaginationParams {
  action?: string;
  super_admin_id?: number;
  tenant_id?: number;
}

export const getLogs = async (
  params?: ActivityLogListParams
): Promise<PaginatedApiResponse<ActivityLog>> => {
  const response = await superAdminApi.get<PaginatedApiResponse<ActivityLog>>(
    RESOURCE,
    { params }
  );

  return response.data;
};

export const downloadActivityLogsCsv = async (
  params?: Omit<ActivityLogListParams, "page" | "per_page">
): Promise<Blob> => {
  const response = await superAdminApi.get(`${RESOURCE}/export.csv`, {
    params,
    responseType: "blob",
  });

  return response.data;
};
